<template>
  <PerfectScrollbar ref="ps" :class="{ mo: isMobile }" :options="scrollOption">
    <slot />
  </PerfectScrollbar>
</template>
<script setup lang="ts">
const props = defineProps({
  options: {
    type: Object,
    default: () => ({})
  }
})
const { $customDevice } = useNuxtApp()
const isMobile = ($customDevice as CustomDevice).isMobileOrTablet

const scrollOption = computed(() => {
  const handlers = ['click-rail', 'keyboard', 'wheel', 'touch']
  if (isMobile === false) {
    handlers.push('drag-thumb')
  }
  return {
    ...props.options,
    handlers,
    wheelPropagation: false,
    minScrollbarLength: 20
  }
})
const ps = ref(null)

defineExpose<{ refPs: any }>({
  refPs: ps
})
</script>
<style lang="scss">
.ps.mo {
  .ps__rail-x:hover,
  .ps__rail-y:hover,
  .ps__rail-x:focus,
  .ps__rail-y:focus,
  .ps__rail-x.ps--clicking,
  .ps__rail-y.ps--clicking {
    opacity: 0.6;
    background-color: transparent;
  }

  .ps__rail-y:hover > .ps__thumb-y,
  .ps__rail-y:focus > .ps__thumb-y,
  .ps__rail-y.ps--clicking .ps__thumb-y {
    width: 6px;
    background-color: #aaa;
  }
}
</style>
